import { useState } from "react";
import { Info, ChevronDown, ChevronUp, X } from "lucide-react";

/**
 * InfoBubble — Reusable collapsible "About this section" hint.
 * Usage: <InfoBubble text="Your guidance text here" />
 */
const InfoBubble = ({ text, title, dismissible = true, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  const [dismissed, setDismissed] = useState(false);

  if (!text || dismissed) return null;

  return (
    <div className="mb-3" data-testid="info-bubble">
      {!open ? (
        <button
          onClick={() => setOpen(true)}
          className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-[11px] text-[#36A9E1] bg-[rgba(54,169,225,0.06)] hover:bg-[rgba(54,169,225,0.1)] border border-[rgba(54,169,225,0.12)] transition-colors"
          data-testid="info-bubble-toggle"
        >
          <Info size={12} />
          <span>{title || "About this section"}</span>
          <ChevronDown size={10} />
        </button>
      ) : (
        <div className="p-3 rounded-lg bg-[rgba(54,169,225,0.04)] border border-[rgba(54,169,225,0.12)]" data-testid="info-bubble-content">
          <div className="flex items-start justify-between gap-2">
            <div className="flex items-start gap-2">
              <Info size={13} className="text-[#36A9E1] shrink-0 mt-0.5" />
              <p className="text-[#B8C7D9] text-[11px] leading-relaxed">{text}</p>
            </div>
            <div className="flex items-center gap-1 shrink-0">
              <button onClick={() => setOpen(false)} className="text-[#8B95A5] hover:text-white" data-testid="info-bubble-collapse">
                <ChevronUp size={12} />
              </button>
              {dismissible && (
                <button onClick={() => setDismissed(true)} className="text-[#8B95A5] hover:text-white" data-testid="info-bubble-dismiss">
                  <X size={12} />
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoBubble;
